import React from "react";
import { Outlet } from "react-router-dom";
import Content from "../../Components/Core/Content";
import { useTenantContent } from "../../Context/TenantContentContext";
import FeatureDisabled from "../../Components/Core/FeatureDisabled";
import Loader from "../../Components/Core/Loader";

const Reservation = () => {
  const { content, loading } = useTenantContent();

  if (loading || !content) return <Loader />;

  if (content && content.isReservationPageEnabled === false) {
    return <FeatureDisabled featureName="صفحه رزرو نوبت" isSubscriptionExpired={content.isSubscriptionExpired} />;
  }

  return (
    <div>
      <Content>
        <Outlet />
      </Content>
    </div>
  );
};

export default Reservation;
